// import { useEffect, useState, useCallback } from 'react';
// import axios from 'axios'; // swap for your existing api client if you have one (e.g. src/api.js)

// /**
//  * Employer/Admin view of AI fraud detection flags.
//  * Route it at /employer/fraud-flags (or /admin/fraud-flags) in App.jsx:
//  *
//  *   import FraudFlags from './pages/FraudFlags';
//  *   <Route
//  *     path="/employer/fraud-flags"
//  *     element={<ProtectedRoute allowedRoles={['employer']}><FraudFlags /></ProtectedRoute>}
//  *   />
//  */
// export default function FraudFlags() {
//   const [flags, setFlags] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selected, setSelected] = useState(null);
//   const [minScore, setMinScore] = useState(0);

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await axios.get('/api/fraud/flags', {
//         params: minScore ? { min_score: minScore } : {},
//       });
//       setFlags(data.data ?? data); // handles paginated or plain array response
//     } catch (err) {
//       setError('Could not load fraud flags.');
//     } finally {
//       setLoading(false);
//     }
//   }, [minScore]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const reviewFlag = async (id, status) => {
//     try {
//       await axios.put(`/api/fraud/flags/${id}/review`, { status });
//       setFlags((prev) => prev.map((f) => (f.id === id ? { ...f, status } : f)));
//       if (selected?.id === id) setSelected((s) => ({ ...s, status }));
//     } catch {
//       setError('Could not update review status.');
//     }
//   };

//   const riskColor = (score) => {
//     if (score >= 75) return '#dc2626';
//     if (score >= 50) return '#ea580c';
//     return '#65a30d';
//   };

//   return (
//     <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
//       <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '4px' }}>AI Fraud Detection</h1>
//       <p style={{ color: '#6b7280', marginBottom: '20px' }}>
//         Applications flagged for duplicate resumes, fake experience, plagiarism, AI-generated content, or spam patterns.
//       </p>

//       <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
//         <label style={{ fontSize: '0.875rem', color: '#374151' }}>Min risk score:</label>
//         <input
//           type="number"
//           min={0}
//           max={100}
//           value={minScore}
//           onChange={(e) => setMinScore(Number(e.target.value))}
//           style={{ width: '80px', padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '6px' }}
//         />
//         <button onClick={load} style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff' }}>
//           Refresh
//         </button>
//       </div>

//       {error && <p style={{ color: '#dc2626' }}>{error}</p>}
//       {loading && <p style={{ color: '#6b7280' }}>Loading…</p>}

//       {!loading && flags.length === 0 && (
//         <p style={{ color: '#6b7280' }}>No flagged applications right now.</p>
//       )}

//       <div style={{ display: 'grid', gap: '10px' }}>
//         {flags.map((flag) => (
//           <div
//             key={flag.id}
//             onClick={() => setSelected(flag)}
//             style={{
//               border: '1px solid #e5e7eb',
//               borderRadius: '10px',
//               padding: '14px 16px',
//               cursor: 'pointer',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               background: selected?.id === flag.id ? '#f9fafb' : '#fff',
//             }}
//           >
//             <div>
//               <div style={{ fontWeight: 600 }}>{flag.candidate?.name ?? `Candidate #${flag.candidate_id}`}</div>
//               <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>{flag.candidate?.email}</div>
//             </div>
//             <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//               <span
//                 style={{
//                   fontWeight: 700,
//                   color: '#fff',
//                   background: riskColor(flag.overall_risk_score),
//                   padding: '2px 10px',
//                   borderRadius: '999px',
//                   fontSize: '0.8rem',
//                 }}
//               >
//                 {flag.overall_risk_score}% risk
//               </span>
//               <span style={{ fontSize: '0.75rem', textTransform: 'capitalize', color: '#6b7280' }}>{flag.status.replace('_', ' ')}</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {selected && (
//         <div style={{ marginTop: '24px', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px' }}>
//           <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '12px' }}>
//             {selected.candidate?.name ?? `Candidate #${selected.candidate_id}`} — detail
//           </h2>

//           <ScoreRow label="Duplicate resume" score={selected.duplicate_score} />
//           <ScoreRow label="Fake experience risk" score={selected.experience_risk_score} />
//           <ScoreRow label="Plagiarism" score={selected.plagiarism_score} />
//           <ScoreRow label="AI-generated content" score={selected.ai_generated_score} />
//           <ScoreRow label="Spam signals" score={selected.spam_score} />

//           {selected.experience_flags?.length > 0 && (
//             <FlagList title="Experience flags" items={selected.experience_flags} />
//           )}
//           {selected.ai_generated_signals?.length > 0 && (
//             <FlagList title="AI-generation signals" items={selected.ai_generated_signals} />
//           )}
//           {selected.spam_signals?.length > 0 && (
//             <FlagList title="Spam signals" items={selected.spam_signals} />
//           )}

//           <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
//             <button onClick={() => reviewFlag(selected.id, 'confirmed_fraud')} style={btnStyle('#dc2626')}>
//               Confirm fraud
//             </button>
//             <button onClick={() => reviewFlag(selected.id, 'under_review')} style={btnStyle('#ea580c')}>
//               Mark under review
//             </button>
//             <button onClick={() => reviewFlag(selected.id, 'dismissed')} style={btnStyle('#65a30d')}>
//               Dismiss (false positive)
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// function ScoreRow({ label, score }) {
//   return (
//     <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f3f4f6' }}>
//       <span style={{ fontSize: '0.875rem', color: '#374151' }}>{label}</span>
//       <span style={{ fontSize: '0.875rem', fontWeight: 600 }}>{score}%</span>
//     </div>
//   );
// }

// function FlagList({ title, items }) {
//   return (
//     <div style={{ marginTop: '14px' }}>
//       <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>{title}</div>
//       <ul style={{ margin: 0, paddingLeft: '18px' }}>
//         {items.map((item, idx) => (
//           <li key={idx} style={{ fontSize: '0.8rem', color: '#6b7280' }}>
//             {item.detail}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// function btnStyle(color) {
//   return {
//     padding: '6px 14px',
//     borderRadius: '6px',
//     border: `1px solid ${color}`,
//     color,
//     background: '#fff',
//     fontSize: '0.8rem',
//     cursor: 'pointer',
//   };
// }




import { useEffect, useState, useCallback } from 'react';
import api from '../api/axios'; // ASSUMPTION: default-exported axios instance at src/api/axios.js — adjust import if your client differs

/**
 * Employer/Admin view of AI fraud detection flags.
 * Route it at /employer/fraud-flags (or /admin/fraud-flags) in App.jsx:
 *
 *   import FraudFlags from './pages/FraudFlags';
 *   <Route
 *     path="/employer/fraud-flags"
 *     element={<ProtectedRoute allowedRoles={['employer']}><FraudFlags /></ProtectedRoute>}
 *   />
 */
export default function FraudFlags() {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [minScore, setMinScore] = useState(0);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get('/fraud/flags', {
        params: minScore ? { min_score: minScore } : {},
      });
      setFlags(data.data ?? data); // handles paginated or plain array response
    } catch (err) {
      setError('Could not load fraud flags.');
    } finally {
      setLoading(false);
    }
  }, [minScore]);

  useEffect(() => {
    load();
  }, [load]);

  const reviewFlag = async (id, status) => {
    try {
      await api.put(`/fraud/flags/${id}/review`, { status });
      setFlags((prev) => prev.map((f) => (f.id === id ? { ...f, status } : f)));
      if (selected?.id === id) setSelected((s) => ({ ...s, status }));
    } catch {
      setError('Could not update review status.');
    }
  };

  const riskColor = (score) => {
    if (score >= 75) return '#dc2626';
    if (score >= 50) return '#ea580c';
    return '#65a30d';
  };

  return (
    <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '4px' }}>AI Fraud Detection</h1>
      <p style={{ color: '#6b7280', marginBottom: '20px' }}>
        Applications flagged for duplicate resumes, fake experience, plagiarism, AI-generated content, or spam patterns.
      </p>

      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
        <label style={{ fontSize: '0.875rem', color: '#374151' }}>Min risk score:</label>
        <input
          type="number"
          min={0}
          max={100}
          value={minScore}
          onChange={(e) => setMinScore(Number(e.target.value))}
          style={{ width: '80px', padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: '6px' }}
        />
        <button onClick={load} style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff' }}>
          Refresh
        </button>
      </div>

      {error && <p style={{ color: '#dc2626' }}>{error}</p>}
      {loading && <p style={{ color: '#6b7280' }}>Loading…</p>}

      {!loading && flags.length === 0 && (
        <p style={{ color: '#6b7280' }}>No flagged applications right now.</p>
      )}

      <div style={{ display: 'grid', gap: '10px' }}>
        {flags.map((flag) => (
          <div
            key={flag.id}
            onClick={() => setSelected(flag)}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: '10px',
              padding: '14px 16px',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: selected?.id === flag.id ? '#f9fafb' : '#fff',
            }}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{flag.candidate?.name ?? `Candidate #${flag.candidate_id}`}</div>
              <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>{flag.candidate?.email}</div>
            </div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span
                style={{
                  fontWeight: 700,
                  color: '#fff',
                  background: riskColor(flag.overall_risk_score),
                  padding: '2px 10px',
                  borderRadius: '999px',
                  fontSize: '0.8rem',
                }}
              >
                {flag.overall_risk_score}% risk
              </span>
              <span style={{ fontSize: '0.75rem', textTransform: 'capitalize', color: '#6b7280' }}>{flag.status.replace('_', ' ')}</span>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div style={{ marginTop: '24px', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px' }}>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '12px' }}>
            {selected.candidate?.name ?? `Candidate #${selected.candidate_id}`} — detail
          </h2>

          <ScoreRow label="Duplicate resume" score={selected.duplicate_score} />
          <ScoreRow label="Fake experience risk" score={selected.experience_risk_score} />
          <ScoreRow label="Plagiarism" score={selected.plagiarism_score} />
          <ScoreRow label="AI-generated content" score={selected.ai_generated_score} />
          <ScoreRow label="Spam signals" score={selected.spam_score} />

          {selected.experience_flags?.length > 0 && (
            <FlagList title="Experience flags" items={selected.experience_flags} />
          )}
          {selected.ai_generated_signals?.length > 0 && (
            <FlagList title="AI-generation signals" items={selected.ai_generated_signals} />
          )}
          {selected.spam_signals?.length > 0 && (
            <FlagList title="Spam signals" items={selected.spam_signals} />
          )}

          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
            <button onClick={() => reviewFlag(selected.id, 'confirmed_fraud')} style={btnStyle('#dc2626')}>
              Confirm fraud
            </button>
            <button onClick={() => reviewFlag(selected.id, 'under_review')} style={btnStyle('#ea580c')}>
              Mark under review
            </button>
            <button onClick={() => reviewFlag(selected.id, 'dismissed')} style={btnStyle('#65a30d')}>
              Dismiss (false positive)
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function ScoreRow({ label, score }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f3f4f6' }}>
      <span style={{ fontSize: '0.875rem', color: '#374151' }}>{label}</span>
      <span style={{ fontSize: '0.875rem', fontWeight: 600 }}>{score}%</span>
    </div>
  );
}

function FlagList({ title, items }) {
  return (
    <div style={{ marginTop: '14px' }}>
      <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>{title}</div>
      <ul style={{ margin: 0, paddingLeft: '18px' }}>
        {items.map((item, idx) => (
          <li key={idx} style={{ fontSize: '0.8rem', color: '#6b7280' }}>
            {item.detail}
          </li>
        ))}
      </ul>
    </div>
  );
}

function btnStyle(color) {
  return {
    padding: '6px 14px',
    borderRadius: '6px',
    border: `1px solid ${color}`,
    color,
    background: '#fff',
    fontSize: '0.8rem',
    cursor: 'pointer',
  };
}